import { createSlice } from "@reduxjs/toolkit";

const productCategorySlice = createSlice({
  name: "productCategory",
  initialState: {
    Trending: false,
    NewArrival: false,
    BestSeller: false,
  },
  reducers: {
    setTrendingCategory(state, action) {
      state.Trending = action.payload;
    },
    setNewArrivalCategory(state, action) {
      state.NewArrival = action.payload;
    },
    setBestSellerCategory(state, action) {
      state.BestSeller = action.payload;
    },
  },
});

export const {
  setTrendingCategory,
  setNewArrivalCategory,
  setBestSellerCategory,
} = productCategorySlice.actions;
export default productCategorySlice.reducer;
